module.exports = __webpack_public_path__ + "img/color_block_10.ccd91130.svg";